import { useQueryClient, useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

const useDeleteRunGroup = (userToken: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ workspaceId, runGroupId }: { workspaceId: number; runGroupId: string }) =>
      fetch(`${ENDPOINTS.run_groups(workspaceId)}/${runGroupId}`, {
        method: "DELETE",
        headers: authHeader(userToken),
      }).then(handleResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["runGroups"]);
      },
    },
  );
};

export default useDeleteRunGroup;
